import { CALL_API } from '../middleware/ApiMiddleware';

export const ROLE_FETCH_REQUEST = 'ROLE_FETCH_REQUEST';
export const ROLE_FETCH_SUCCESS = 'ROLE_FETCH_SUCCESS';
export const ROLE_FETCH_FAILURE = 'ROLE_FETCH_FAILURE';

export const ROLE_CREATE_REQUEST = 'ROLE_CREATE_REQUEST';
export const ROLE_CREATE_SUCCESS = 'ROLE_CREATE_SUCCESS';
export const ROLE_CREATE_FAILURE = 'ROLE_CREATE_FAILURE';

export const ROLE_UPDATE_REQUEST = 'ROLE_UPDATE_REQUEST';
export const ROLE_UPDATE_SUCCESS = 'ROLE_UPDATE_SUCCESS';
export const ROLE_UPDATE_FAILURE = 'ROLE_UPDATE_FAILURE';

export const ROLES_FETCH_REQUEST = 'ROLES_FETCH_REQUEST';
export const ROLES_FETCH_SUCCESS = 'ROLES_FETCH_SUCCESS';
export const ROLES_FETCH_FAILURE = 'ROLES_FETCH_FAILURE';

export const fetchRole = (roleId: number) => ({
  [CALL_API]: {
    endpoint: `roles/${roleId}`,
    method: 'get',
    authenticated: true,
    types: [ROLE_FETCH_REQUEST, ROLE_FETCH_SUCCESS, ROLE_FETCH_FAILURE],
  },
});

export const createRole = (group: IRole) => ({
  [CALL_API]: {
    endpoint: 'roles',
    method: 'post',
    body: group,
    authenticated: true,
    types: [ROLE_CREATE_REQUEST, ROLE_CREATE_SUCCESS, ROLE_CREATE_FAILURE],
  },
});

export const updateRole = (roleId: number, group: IRole) => ({
  [CALL_API]: {
    endpoint: `roles/${roleId}`,
    method: 'put',
    body: group,
    authenticated: true,
    types: [ROLE_UPDATE_REQUEST, ROLE_UPDATE_SUCCESS, ROLE_UPDATE_FAILURE],
  },
});

export const fetchRoles = () => ({
  [CALL_API]: {
    endpoint: 'roles',
    method: 'get',
    authenticated: true,
    types: [ROLES_FETCH_REQUEST, ROLES_FETCH_SUCCESS, ROLES_FETCH_FAILURE],
  },
});

export const fetchRolesWithAgencyId = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `roles?agencyId=${agencyId}`,
    method: 'get',
    authenticated: true,
    types: [ROLES_FETCH_REQUEST, ROLES_FETCH_SUCCESS, ROLES_FETCH_FAILURE],
  },
});
